<template>
    <router-link :to="`/personal-channel/${member.id}`" :disabled="member.id === userData.id" tag="button">
        <span
                class="user-status"
                :class="{'is-online' : member.is_online}"
        >
        </span>
        <em>{{ member.last_name }} {{ member.first_name }} {{ teacherPatronymic(member) }}</em>
    </router-link>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        props: ['member'],
        computed: {
            ...mapGetters(['userData'])
        },
        methods: {
            teacherPatronymic(member) {
                if (member.role === 'owner' || member.role === 'teacher' || member.role === 'admin') {
                    return member.patronymic
                }
            }
        }
    }
</script>

<style>
    .chat-group a:hover{
        cursor:default;
    }
</style>

